import { useMemo, useState } from 'react';
import { useAuthContext } from '../contexts/AuthProvider';
import { FeatureName } from '../types/features';
import { Permissions } from '../types/permissions';

const useFeatureBasedPermissions = (featureName: FeatureName) => {
  // integration of react hooks here
  const [featureBasedPermissions, setFeatureBasedPermissions] =
    useState<Array<Permissions> | null>(null);

  // integration of context hooks here
  const { currentUserPermissions } = useAuthContext();

  // extracting current user's feature based permissions here
  useMemo(() => {
    if (currentUserPermissions.length) {
      const existingPermissions = currentUserPermissions.find(
        (permission) =>
          permission.feature.toLowerCase() === featureName.toLowerCase()
      );

      if (existingPermissions) {
        setFeatureBasedPermissions(existingPermissions.permission_names);
      } else {
        setFeatureBasedPermissions([]);
      }
    }
  }, [currentUserPermissions, featureName]);

  // checking if current user has read permission or not here
  const hasReadPermission = (featureName: string): boolean => {
    const existingPermissions = currentUserPermissions.find(
      (permission) =>
        permission.feature.toLowerCase() === featureName.toLowerCase()
    );

    return existingPermissions?.permission_names.includes('READ') || false;
  };

  return { featureBasedPermissions, hasReadPermission };
};

export default useFeatureBasedPermissions;
